import React from "react";
import { IconPDF } from "../svgIcons/pdf";
import { downloadExternalIcon } from "../svgIcons";
export const DownloadButton = ({ href, label, style }) => (React.createElement("a", { href: href, className: "download-button h5-bold", style: style, target: "_blank", rel: "noreferrer" },
    IconPDF,
    " ",
    label,
    " ",
    downloadExternalIcon({})));
